import { render, staticRenderFns } from "./IssuanceForm.vue?vue&type=template&id=066cebdb&scoped=true"
import script from "./IssuanceForm.vue?vue&type=script&lang=js"
export * from "./IssuanceForm.vue?vue&type=script&lang=js"
import style0 from "./IssuanceForm.vue?vue&type=style&index=0&id=066cebdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066cebdb",
  null
  
)

export default component.exports